import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useUser } from "../../contexts/UserContextProvider";

export default function PrivateRoute(props) {
    const [user] = useUser();

    return user ? <Route {...props} /> : <Redirect to="/login" />;
}
